export default "__VITE_ASSET__DZ$JEzgX__"